import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Button, Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { ColTitleEvent } from './modalSelectEvent/style';
import { StyledStatusPayment } from './styled';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { paymentStatus } from '../../../config/constants/statusPaymentConstants';

export function EventTitle({ event }) {
  const { translate: t } = useDictionaryTranslation();

  const getStatusPaymentById = (idStatus) => {
    const statusPayment = Object.values(paymentStatus).find((status) =>
      status.id === idStatus ? idStatus : paymentStatus,
    );
    if (!statusPayment) {
      return null;
    }
    return (
      <StyledStatusPayment status={statusPayment?.color} color={statusPayment?.color}>
        {t(statusPayment?.name)}
      </StyledStatusPayment>
    );
  };

  return (
    <ColTitleEvent xs={24} md={20} className="event-attr">
      <Row>
        <Col xs={24} md={12} className="textService">
          <span className="event-title">
            {t('serviceInformation')} <strong>#{event.privateId}</strong>
          </span>
        </Col>
        <Col xs={24} md={2} className="icon">
          <Row>
            <Link to={`/services-detail/${event.id}/service/`}>
              <Button className="btonIcon">
                <FeatherIcon icon="alert-circle" size={18} />
              </Button>
            </Link>
          </Row>
        </Col>

        <Col xs={24} md={10}>
          {getStatusPaymentById(event?.paymentStatus)}
        </Col>
      </Row>
    </ColTitleEvent>
  );
}

EventTitle.propTypes = {
  event: PropTypes.shape({
    idColor: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    privateId: PropTypes.string,
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    assignedUser: PropTypes.string,
    assignedServiceType: PropTypes.string,
    confirmedByFinalCustomer: PropTypes.bool,
    confirmedByUser: PropTypes.bool,
    infoAssignedCompany: PropTypes.string,
    assignedFinalCustomer: PropTypes.object,
    data: PropTypes.object,
    paymentStatus: PropTypes.string,
  }),
};
